export class configuracionEsquema{
    idEsquema:number;
    idInstitucion:number;
    idPlantilla:number;
    idTipoBin:number;
    esquema:string;
    institucion:string;
    plantilla:string;
    tipoBin:string;
}